/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_SecurityFunctionInquiry from "./SecurityFunctionInquiry";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("SecurityFunctionInquiry Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_SecurityFunctionInquiry />
      );
    });
  });
  afterEach(cleanup);
  test("is SecurityFunctionInquiry Loads Successfully", () => {
    expect(screen.getByText("SecurityFunctionInquiry")).toBeInTheDocument;
  });
  test("Custom Test Cases for SecurityFunctionInquiry", () => {
    // START_USER_CODE-USER_SecurityFunctionInquiry_Custom_Test_Case
    // END_USER_CODE-USER_SecurityFunctionInquiry_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceSpecialFunctions_SecurityFunctionInquiry />
      );
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnCancel(Button Widget) Test Cases", async () => {
    const btnCancel = screen.getByTestId("btnCancel");
    expect(btnCancel).toBeInTheDocument;
    expect(btnCancel.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_btnCancel")
    );
  });
  test("Custom Test Cases for btnCancel", () => {
    // START_USER_CODE-USER_btnCancel_TEST
    // END_USER_CODE-USER_btnCancel_TEST
  });
  test("grpbxActions(GroupBox Widget) Test Cases", async () => {
    const grpbxActions = screen.getByTestId("grpbxActions");
    expect(grpbxActions.tagName).toBe("BUTTON");
    expect(grpbxActions.type).toBe("button");
    expect(grpbxActions.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxActions", () => {
    // START_USER_CODE-USER_grpbxActions_TEST
    // END_USER_CODE-USER_grpbxActions_TEST
  });
  test("grpbxSecurityFunctionInquiry(GroupBox Widget) Test Cases", async () => {
    const grpbxSecurityFunctionInquiry = screen.getByTestId(
      "grpbxSecurityFunctionInquiry"
    );
    expect(grpbxSecurityFunctionInquiry.tagName).toBe("BUTTON");
    expect(grpbxSecurityFunctionInquiry.type).toBe("button");
    expect(grpbxSecurityFunctionInquiry.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxSecurityFunctionInquiry", () => {
    // START_USER_CODE-USER_grpbxSecurityFunctionInquiry_TEST
    // END_USER_CODE-USER_grpbxSecurityFunctionInquiry_TEST
  });
  test("lblAddedBy(Label Widget) Test Cases", async () => {
    const lblAddedBy = screen.getByTestId("lblAddedBy");
    expect(lblAddedBy.tagName).toBe("LABEL");
    expect(lblAddedBy.classList).toContain("form-label");
    expect(lblAddedBy.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_lblAddedBy")
    );
  });
  test("Custom Test Cases for lblAddedBy", () => {
    // START_USER_CODE-USER_lblAddedBy_TEST
    // END_USER_CODE-USER_lblAddedBy_TEST
  });
  test("lblAddedByValue(Label Widget) Test Cases", async () => {
    const lblAddedByValue = screen.getByTestId("lblAddedByValue");
    expect(lblAddedByValue.tagName).toBe("LABEL");
    expect(lblAddedByValue.classList).toContain("form-label");
    expect(lblAddedByValue.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_lblAddedByValue"
      )
    );
  });
  test("Custom Test Cases for lblAddedByValue", () => {
    // START_USER_CODE-USER_lblAddedByValue_TEST
    // END_USER_CODE-USER_lblAddedByValue_TEST
  });
  test("lblChangedBy(Label Widget) Test Cases", async () => {
    const lblChangedBy = screen.getByTestId("lblChangedBy");
    expect(lblChangedBy.tagName).toBe("LABEL");
    expect(lblChangedBy.classList).toContain("form-label");
    expect(lblChangedBy.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_lblChangedBy"
      )
    );
  });
  test("Custom Test Cases for lblChangedBy", () => {
    // START_USER_CODE-USER_lblChangedBy_TEST
    // END_USER_CODE-USER_lblChangedBy_TEST
  });
  test("lblChangedByValue(Label Widget) Test Cases", async () => {
    const lblChangedByValue = screen.getByTestId("lblChangedByValue");
    expect(lblChangedByValue.tagName).toBe("LABEL");
    expect(lblChangedByValue.classList).toContain("form-label");
    expect(lblChangedByValue.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_lblChangedByValue"
      )
    );
  });
  test("Custom Test Cases for lblChangedByValue", () => {
    // START_USER_CODE-USER_lblChangedByValue_TEST
    // END_USER_CODE-USER_lblChangedByValue_TEST
  });
  test("txtFunction(Textbox Widget) Test Cases", async () => {
    const txtFunction = screen.getByTestId("txtFunction");
    expect(txtFunction.tagName).toBe("INPUT");
    expect(txtFunction.type).toBe("text");
    expect(txtFunction.classList).toContain("textboxWidgetClass");
    expect(txtFunction.previousElementSibling.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_txtFunction")
    );
    await act(async () => {
      userEvent.type(txtFunction, "1");
    });
  });
  test("Custom Test Cases for txtFunction", () => {
    // START_USER_CODE-USER_txtFunction_TEST
    // END_USER_CODE-USER_txtFunction_TEST
  });
  test("txtFunctionDiscription(Textbox Widget) Test Cases", async () => {
    const txtFunctionDiscription = screen.getByTestId("txtFunctionDiscription");
    expect(txtFunctionDiscription.tagName).toBe("INPUT");
    expect(txtFunctionDiscription.type).toBe("text");
    expect(txtFunctionDiscription.classList).toContain("textboxWidgetClass");
    expect(txtFunctionDiscription.previousElementSibling.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_txtFunctionDiscription"
      )
    );
    await act(async () => {
      userEvent.type(txtFunctionDiscription, "1");
    });
  });
  test("Custom Test Cases for txtFunctionDiscription", () => {
    // START_USER_CODE-USER_txtFunctionDiscription_TEST
    // END_USER_CODE-USER_txtFunctionDiscription_TEST
  });
  test("txtSubFunction(Textbox Widget) Test Cases", async () => {
    const txtSubFunction = screen.getByTestId("txtSubFunction");
    expect(txtSubFunction.tagName).toBe("INPUT");
    expect(txtSubFunction.type).toBe("text");
    expect(txtSubFunction.classList).toContain("textboxWidgetClass");
    expect(txtSubFunction.previousElementSibling.textContent).toEqual(
      t(
        "SystemMaintenanceSpecialFunctions:SecurityFunctionInquiry_txtSubFunction"
      )
    );
    await act(async () => {
      userEvent.type(txtSubFunction, "1");
    });
  });
  test("Custom Test Cases for txtSubFunction", () => {
    // START_USER_CODE-USER_txtSubFunction_TEST
    // END_USER_CODE-USER_txtSubFunction_TEST
  });
});
